/**
 * useDocumentMeta — sets <title> and <meta name="description"> per route.
 * Lightweight alternative to react-helmet; we update the live DOM and restore
 * the previous values on unmount so crawlers always see route-specific tags.
 */
import { useEffect } from "react";

export function useDocumentMeta({ title, description }) {
    useEffect(() => {
        const prevTitle = document.title;
        if (title) document.title = title;

        let meta = document.querySelector('meta[name="description"]');
        const created = !meta;
        if (!meta) {
            meta = document.createElement("meta");
            meta.setAttribute("name", "description");
            document.head.appendChild(meta);
        }
        const prevDesc = meta.getAttribute("content") || "";
        if (description) meta.setAttribute("content", description);

        return () => {
            document.title = prevTitle;
            if (created) {
                meta.remove();
            } else {
                meta.setAttribute("content", prevDesc);
            }
        };
    }, [title, description]);
}
